import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0237b69f = () => interopDefault(import('..\\pages\\backup.vue' /* webpackChunkName: "pages_backup" */))
const _242fecc8 = () => interopDefault(import('..\\pages\\login.vue' /* webpackChunkName: "pages_login" */))
const _1c2a3267 = () => interopDefault(import('..\\pages\\logout.vue' /* webpackChunkName: "pages_logout" */))
const _5861b8c7 = () => interopDefault(import('..\\pages\\pazienti\\index.vue' /* webpackChunkName: "pages_pazienti_index" */))
const _0c5df8b3 = () => interopDefault(import('..\\pages\\pazienti\\_id\\index.vue' /* webpackChunkName: "pages_pazienti__id_index" */))
const _5f6e0a39 = () => interopDefault(import('..\\pages\\pazienti\\_id\\privacy\\index.vue' /* webpackChunkName: "pages_pazienti__id_privacy_index" */))
const _eef78e18 = () => interopDefault(import('..\\pages\\pazienti\\_id\\trattamenti\\index.vue' /* webpackChunkName: "pages_pazienti__id_trattamenti_index" */))
const _a1874346 = () => interopDefault(import('..\\pages\\pazienti\\_id\\trattamenti\\_trattamentoid.vue' /* webpackChunkName: "pages_pazienti__id_trattamenti__trattamentoid" */))
const _24406685 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/backup",
    component: _0237b69f,
    name: "backup"
  }, {
    path: "/login",
    component: _242fecc8,
    name: "login"
  }, {
    path: "/logout",
    component: _1c2a3267,
    name: "logout"
  }, {
    path: "/pazienti",
    component: _5861b8c7,
    name: "pazienti"
  }, {
    path: "/pazienti/:id",
    component: _0c5df8b3,
    name: "pazienti-id"
  }, {
    path: "/pazienti/:id/privacy",
    component: _5f6e0a39,
    name: "pazienti-id-privacy"
  }, {
    path: "/pazienti/:id/trattamenti",
    component: _eef78e18,
    name: "pazienti-id-trattamenti"
  }, {
    path: "/pazienti/:id/trattamenti/:trattamentoid",
    component: _a1874346,
    name: "pazienti-id-trattamenti-trattamentoid"
  }, {
    path: "/",
    component: _24406685,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
